import { EChatWindowActionTypes } from '../../actions/chatWindow';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function chatWindowReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EChatWindowActionTypes.OpenChat:
      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          currentOpenedChatId: action.payload,
        },
      };

    case EChatWindowActionTypes.CloseChat:
      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          currentOpenedChatId: '',
        },
      };

    case EChatWindowActionTypes.ResetChat:
      return {
        ...state,
        chatWindow: {
          isChatOperationPending: false,
          isBubbleInputFocused: false,
          currentOpenedChatId: null,
          countClosedChats: 0,
        },
      };
    case EChatWindowActionTypes.IncreaseCountClosedChats:
      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          countClosedChats: state.chatWindow.countClosedChats + 1,
        },
      };

    default:
      return state;
  }
}
